import { EventListInfo, EventListPublish, EventListPublishInstance } from "../store/share.event-lists.data"
import { dateIdCompare, jsonCopyObject, sortByProp } from "./helpers"
import { MonthAbbr } from "./constants"


const extractDateParts = (dateId: string) => {
  if (!dateId) return null
  const groups = dateId.match(/(\d{4})\/(\d{2})\/(\d{2})/)
  return { d: +groups[3], m: +groups[2] - 1, y: +groups[1] }
}

export const extractStartEndDateParts = (dates: { start: string, end: string }) => {
  // console.log(dates)
  if (!dates) return null
  return { s: extractDateParts(dates.start), e: extractDateParts(dates.end) }
}

export const getEventListPublishInstance = // don't pass in instance except when going through functions for an already published Event list.  
(eventName: string, eventId: string, publishes: EventListPublish[], eventListInfo: EventListInfo, originalIndex: number, instance?: EventListPublishInstance): 
EventListPublishInstance => {
  if (!publishes?.length) return null

  const noDatePublishes = publishes.filter(p => !p.dates)
  const datedPublishes = publishes.filter(p => !!p.dates)
  const allDates = extractEventDatesFromEventListInstancePublishes(publishes)
  const dateParts = extractStartEndDateParts(allDates)
  const dateBlocks = !dateParts ? null : { 
    start: { day: dateParts.s.d, month: MonthAbbr[dateParts.s.m] },
    end: { day: dateParts.e.d, month: MonthAbbr[dateParts.e.m] },
  }
  const { excludedFieldIds: excludedIds } = eventListInfo
  const publishInstance: EventListPublishInstance = {
    eventName: eventName || '',
    eventId,
    dates: allDates || null,
    dateBlocks,
    publishes: [...noDatePublishes.sort(sortByProp('name')), ...datedPublishes.sort((a,b) => new Date(a.dates.start).getTime() - new Date(b.dates.start).getTime())],
    thumbnail: instance ? instance.thumbnail : (eventListInfo.instanceThumbs[eventId] || [])[originalIndex] || null,
    index: originalIndex
  }
  console.log({ eventName, eventId, publishes, excludedIds, eventListInfo, originalIndex, publishInstance })

  return publishInstance

}


export const extractEventDatesFromEventListInstancePublishes = (eventListPublishes: EventListPublish[]): { start: string, end: string } => {
  let allDates: { start: string, end: string } = null
  eventListPublishes.filter(p => p.dates).forEach(p => {
    if (!allDates) allDates = jsonCopyObject(p.dates)
    else allDates = { start: dateIdCompare(p.dates.start, allDates.start), end: dateIdCompare(p.dates.end, allDates.end, false) }
  })
  return allDates
}
  